import {
	Children,
	cloneElement,
	FC,
	isValidElement,
	ReactElement,
} from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import RadioButton from "./RadioButton/RadioButton";

import { RadioGroupProps, RadioGroupSubComponents } from "./RadioGroup.types";
import { StyledRadioGroup } from "./styling/RadioGroup.styles";

const INVALID_CHILD_ERROR_MESSAGE =
	"Invalid RadioGroup subcomponent: The child you provided is not a valid RadioGroup subcomponent, please provide RadioGroup.Button subcomponent";

const RadioGroup: FC<RadioGroupProps> & RadioGroupSubComponents = ({
	name,
	value,
	children,
	className,
	colorOn,
	...props
}) => {
	const block = new BemIt("RadioGroup");

	const radioButtons = Children.map(children, (child, index) => {
		if (isValidElement(child)) {
			const isItem = child.type === RadioButton;
			const checked = value === child.props.value;

			if (!isItem) {
				console.error(INVALID_CHILD_ERROR_MESSAGE);
				return null;
			}

			return (
				isValidElement(child) &&
				cloneElement(child as ReactElement, {
					key: index,
					checked,
					name,
					colorOn,
				})
			);
		}
	});
	return (
		<StyledRadioGroup className={addClass(className).after(block)} {...props}>
			{radioButtons}
		</StyledRadioGroup>
	);
};

RadioGroup.Button = RadioButton;

export default RadioGroup;
